import React, { useCallback, useState } from 'react';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { LockOutlined, MailOutlined } from '@ant-design/icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, Form, Input, ConfigProvider } from 'antd-v5';
import { gAlch } from './helpers/Alch';
import { LoginHandler } from './helpers/loginApi';
import { handleLoginRememberMe } from './helpers';

const LoginLayout = ({ redirectTo, postLoginCallback = () => { } }) => {
  const [form] = Form.useForm();
  const [errorMsg, setErrorMsg] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const currentYear = new Date().getFullYear();

  const customTheme = {
    components: {
      Input: {
        colorFillSecondary: '#e0eeff', // Background when hovered (for filled variant)
        colorFillTertiary: '#e6f4ff', // Background when active/focused
      },
    },
  };

  const onFinish = useCallback(async values => {
    setIsButtonDisabled(true);
    try {
      const { email, password, remember } = values;
      const tkNa = await gAlch({ emailText: email, pwText: password });
      if (!tkNa?.tKn) {
        setIsButtonDisabled(false);
        setErrorMsg('Login error');
        return;
      }
      const newLogin = new LoginHandler('basic', null);
      const authResp = await newLogin.loginHandler({ tKn: tkNa?.tKn, ...tkNa?.auth }, {});
      if (authResp?.error) {
        const err = authResp.error;
        if (typeof err === 'string') {
          setErrorMsg(err);
        } else {
          setErrorMsg('Login error');
        }
        if (err.response && err.response.data && err.response.data.message) {
          if (typeof err.response.data.message !== 'string') {
            console.error({ error: JSON.stringify(err.response.data.message) });
          } else {
            console.error({ error: err.response.data.message.split('"').join('') });
          }
        } else {
          console.error({ error: 'Server error' });
        }
      }
      if (authResp?.merchantId) {
        const { token } = authResp;
        handleLoginRememberMe(remember, token, authResp);
        await postLoginCallback();
        setRedirect(true);
      }
    } catch (e) {
      setIsButtonDisabled(false);
      setErrorMsg('Login error');
      console.error(e);
    } finally {
      setIsButtonDisabled(false);
    }
  }, []);

  return (
    <div>
      <img alt="#" src="https://dashboard-v2-images.s3.amazonaws.com/logo-gray.svg" className="login-top-left-logo" />
      <div className="left-login-panel" />
      <div className="right-login-panel">
        <img alt="#" src="https://dashboard-v2-images.s3.amazonaws.com/logo-mark.svg" />
        <span className="login-title">Dashboard</span>
        <Form
          style={{
            width: '400px',
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '8px',
          }}
          layout="vertical"
          form={form}
          onFinish={onFinish}
          disabled={isButtonDisabled}
          initialValues={{
            remember: true,
          }}
          validateTrigger="onSubmit"
        >
          <ConfigProvider theme={customTheme}>

            <h5 className="error-text">{errorMsg || ''}</h5>
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please input your Email!' },
                { type: 'email', message: 'The input is not valid E-mail!' },
              ]}
            >
              <Input variant="filled" size="large" prefix={<FontAwesomeIcon className='p-right-6' icon={['far', 'envelope']} size='lg' />} placeholder="Email Address" className="w-100-P" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please input your Password!' }]}
            >
              <Input variant="filled" size="large" prefix={<FontAwesomeIcon className='p-right-6' icon={['far', 'lock']} size='lg' />} placeholder="Password" type="password" className="w-100-P" />
            </Form.Item>
            <div className="flex-row-spacebetween-nowrap items-center w-100-P m-btm-16">
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox className="items-center">Remember me</Checkbox>
              </Form.Item>
              <Button type="link" href="/Login/reset-password">
                Forgot password?
              </Button>
            </div>
            <Button
              type="primary"
              htmlType="submit"
              className="w-100-P"
              loading={isButtonDisabled}
              disabled={isButtonDisabled}
            >
              Log in
            </Button>
          </ConfigProvider>

        </Form>
        <div className="info-footer">
          <span className="fs-12">
            <a rel="noopener noreferrer" target="_blank" className="unstyleA" href="https://clientbook.com/">
              Clientbook
            </a>
            <a rel="noopener noreferrer" target="_blank" className="unstyleA" href="https://clientbook.com/blog/">
              Blog
            </a>
            <a rel="noopener noreferrer" target="_blank" className="unstyleA" href="https://help.clientbook.com/en/">
              Help
            </a>
          </span>
          <span className="fs-12">© {currentYear} Clientbook Inc. All rights reserved.</span>
        </div>
      </div>
      {redirect ? <Redirect to={redirectTo || '/'} /> : null}
    </div>
  );
};
const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => ({
  setAuth(account, token) {
    dispatch({
      type: 'SET_AUTH',
      payload: { account, token },
    });
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(LoginLayout);
